import { Modal, Input, Checkbox, MultiSelect, Avatar } from "@mantine/core";

import React, { useState, useEffect } from "react";

import PrimaryButton from "components/primaryButton";
import SecondaryButton from "components/secondaryButton";
import { Controller, useForm } from "react-hook-form";
import { useWindowSize } from "react-use";
import useGetEmployeesList from "pages/projects/pages/myProjects/hooks/useGetEmployeesList";

import sendicon from "assets/icons/sendicon.svg";
import deleteicon from "assets/icons/deleteIcon2.svg";
import { ReactComponent as DownArrow } from "assets/icons/downArrow.svg";

import { ReactComponent as CrossIcon } from "assets/icons/crossIcon.svg";

import JoditEditor from "jodit-react";
import dayjs from "dayjs";
import UseSendMail from "../hooks/useSendMail";

const config = {
  minHeight: 300,

  autofocus: false,
  maxHeight: 600,
  readonly: false,
  fullsize: false,
  globalFullSize: false,
  uploader: {
    insertImageAsBase64URI: true,
  },
  useSearch: false,
  spellcheck: true,
  controls: {
    font: {
      list: {
        "lato, sans-serif": "lato",
        "Raleway, sans-serif": "Raleway",
      },
    },
  },
  // toolbarAdaptive: false,
  style: {
    background: "#FFF4F1",
  },

  // all options from https://xdsoft.net/jodit/doc/
};

const Composemail = (props) => {
  const { opened, setOpened } = props;
  const formData = props?.data;

  const action = props?.action;

  let customFrom = [];
  customFrom.push(formData?.from_addr[0]?.email);

  const [isDraft, setIsDraft] = useState(false);
  const [isCcVisible, setIsCcVisible] = useState(false);
  const [isBccVisible, setIsBccVisible] = useState(false);

  // ... other code

  const handleBccButtonToggle = () => {
    setIsBccVisible((prev) => !prev);
  };

  const { width } = useWindowSize();
  const closeModal = () => {
    setIsDraft(false);
    setOpened(false);

    reset({});
  };

  const {
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      to: [],
      subject: "",
      cc: [],
      body: "",
    },
  });

  // preparing body for forward mail
  const myBody = `<div> 
  <p readonly ><strong>From: </strong>${formData?.from_addr[0]?.email}</p>
  <p><strong>Sent: </strong>${dayjs(formData?.created_time).format(
    "ddd,MMM hh:mm A"
  )}</p>
  <p><strong>To: </strong>${formData?.to?.map((mail) => {
    return mail?.email;
  })}</p>
  ${
    formData?.cc[0]?.email
      ? `<p><strong>Cc: </strong>${formData?.cc
          .map((mail) => mail?.email)
          .join(", ")}</p>`
      : ""
  }
  
  <p><strong>Subject: </strong>${formData?.subject} </p>
  <div>${formData?.body}</div>
  <hr><dl><br>
</dl>
  
  </div>`;

  // setting form values if data is present.
  useEffect(() => {
    if (formData) {
      setValue(
        "to",
        action === "forward"
          ? []
          : action === "reply"
          ? customFrom
          : formData.to?.map((mail) => mail?.email)
      ); // if mail type forward => to should be empty, else if mail type is reply to address will be from adddress
      setValue("body", action === "forward" ? myBody : formData?.body);

      setValue(
        "cc",
        action === "forward"
          ? []
          : action === "reply"
          ? []
          : formData?.cc?.map((mail) => mail?.email)
      ); //if mail type forward => cc should be empty, else if the mail type is reply there will be no cc data
      setValue(
        "subject",
        action === "forward"
          ? "Fw :" + formData?.subject
          : action === "reply" || action === "replyall"
          ? "Re :" + formData?.subject
          : formData?.subject
      );
    }
    // eslint-disable-next-line
  }, [formData, action, setValue]);
  const sendMail = UseSendMail(closeModal);
  let headingText = "";
  if (action === "reply" || action === "replyall") {
    headingText = "Replying mail";
  } else if (action === "forward") {
    headingText = "Forwarding Mail";
  } else {
    headingText = "Composing an mail";
  }

  //onsubmit
  const Submit = (data) => {
    delete data?.bcc;
    delete data?.checkbox;
    delete data?.jodit;
    data = { ...data, id: formData?.id };
    if (isDraft === true) {
      data = { ...data, is_draft: true };
    }
    if (data?.cc === "") {
      data = { ...data, cc: [] };
    }
    if (action === "reply" || action === "replyall" || action === "forward") {
      data = { ...data, is_append_mail: true };
    }
    sendMail.mutate(data);
  };

  //onclose

  //model size
  function modelsize() {
    if (width >= 1280 && width <= 1535) {
      return "lg";
    } else if (width >= 1536 && width <= 1919) {
      return "xl";
    } else if (width >= 1920) {
      return "2xl";
    }
  }
  const size1 = modelsize();

  //error message
  const errorMessage = (name) => {
    return (
      errors[name] && (
        <p className="text-[#fc0101] text-sm font-bold 2xl:text-lg 3xl:text-xl">
          {errors[name]?.message}
        </p>
      )
    );
  };
  const getEmployeesList = useGetEmployeesList();
  //   custom dropdown item for select
  const SelectItem = ({
    activeStatus,
    value,
    label,
    image,
    name,
    description,
    ...others
  }) => {
    return (
      <div className={`flex px-5 `}>
        <div
          {...others}
          className={`flex items-center py-2 cursor-pointer  ${
            activeStatus ? "" : "opacity-60"
          } `}
        >
          <Avatar src={image} color="red">
            {label?.[0]?.toUpperCase()}
          </Avatar>
          <div className="pl-1 ">
            <p className="text-18 ">{label} </p>
            <p className="text-xs text-gray3 pt-1 ">{value} </p>
          </div>
        </div>

        <p className="ml-auto">
          {activeStatus ? (
            <span className="ml-3 text-[12px] text-[#28B446] bg-[#c1f3cc] py-1 px-2 rounded-lg ">
              Active
            </span>
          ) : (
            <span className="ml-3 text-[12px] text-[#D0342C] bg-[#f7bab6] py-1 px-2 rounded-lg">
              Inactive
            </span>
          )}
        </p>
      </div>
    );
  };

  const [data, setData] = useState([]);
  //   dropdown values for team member multi select input
  const getDropdownData = () => {
    const dataArray = [];

    getEmployeesList?.data?.data?.forEach((employee) => {
      dataArray.push({
        activeStatus: employee?.user__is_active,
        image: employee?.profile_picture,
        label: employee.user__first_name,
        value: `${employee?.user__email}`,
        description: employee?.designation__name,
        disabled: employee?.user__is_active ? false : true,
      });
    });
    return dataArray?.concat(data);
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => closeModal()}
        size={size1}
        centered
        withCloseButton={false}
        transitionDuration={100}
        overlayBlur={20}
        overlayOpacity={0.5}
        overlayColor={"#F8F7F799"}
        overflow="inside"
        classNames={{
          body: "scroller h-auto",
        }}
      >
        <div className="flex items-center sticky w-full top-0 bg-white z-20">
          <h1 className="text-lg font-semibold mx-auto text-333333 2xl:text-2xl 3xl:text-3xl">
            {headingText}
          </h1>
          <CrossIcon
            className="w-16 h-16 cursor-pointer 2xl:w-18 3xl:w-20"
            onClick={() => setOpened(false)}
          />
        </div>

        <form
          className="flex flex-col py-2 mx-1 pr-4"
          onSubmit={handleSubmit(Submit)}
        >
          <div className="items-center gap-x-6  hidden ">
            {
              // This section is made hidden as the features are repetative.
            }
            <div
              div
              className="flex items-center gap-x-2 cursor-pointer p-1.5  hover:bg-F8F7F7"
            >
              <img
                src={sendicon}
                alt="sendicon"
                className="w-4 h-4 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6"
              />
              <h1 className="text-sm 2xl:text-lg 3xl:text-xl cursor-not-allowed">
                Send
              </h1>
            </div>

            <div
              className="flex items-center gap-x-2 cursor-pointer p-1.5 rounded hover:bg-F8F7F7"
              onClick={() => setOpened(false)}
            >
              <img
                src={deleteicon}
                alt="deleteicon"
                className="w-4 h-4 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6"
              />
              <h1 className="text-sm 2xl:text-lg 3xl:text-xl">Delete</h1>
            </div>

            {/* <div className='flex items-center gap-x-2 cursor-pointer'>
              <img src={attachicon} alt='attachicon' className='w-4 h-4' />
              <input type='file' placeholder='Attach' />
            </div> */}
          </div>
          <div className="my-3">
            <Controller
              name="to"
              control={control}
              rules={{ required: "required" }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  size="md"
                  itemComponent={SelectItem}
                  placeholder="To"
                  searchable
                  creatable
                  onCreate={(query) => {
                    const item = { value: query, label: query };
                    setData((current) => [...current, item]);
                    return item;
                  }}
                  getCreateLabel={(query) => `Use this address: ${query}`}
                  data={
                    !getEmployeesList?.data?.data?.length
                      ? []
                      : getDropdownData()
                  }
                  rightSection={<DownArrow />}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  classNames={{
                    input: "border-primary truncate min-h-[7vh]",
                    label: "text-neutralsGrey text-sm",
                  }}
                />
              )}
            />
            {errorMessage("to")}
          </div>
          <div className="mb-5">
            <Controller
              name="cc"
              control={control}
              // rules={{ required: 'required' }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  size="md"
                  itemComponent={SelectItem}
                  placeholder="Cc"
                  searchable
                  creatable
                  onCreate={(query) => {
                    const item = { value: query, label: query };
                    setData((current) => [...current, item]);
                    return item;
                  }}
                  getCreateLabel={(query) => `Use this address: ${query}`}
                  data={
                    !getEmployeesList?.data?.data?.length
                      ? []
                      : getDropdownData()
                  }
                  rightSection={<DownArrow />}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  classNames={{
                    input: "border-primary truncate min-h-[7vh]",
                    label: "text-neutralsGrey text-sm",
                  }}
                />
              )}
            />

            {errorMessage("cc")}
          </div>

          <div className='my-3 mb-10'>
        {/* Bcc Section */}
        <Controller
          name='bcc'
          control={control}
          render={({ field }) => (
            <div className='relative'>
              <button
                className='absolute right-4 top-2 px-2 py-1  z-30 bg-primary text-white rounded cursor-pointer'
                type='button'
                onClick={handleBccButtonToggle}
              >
                {isBccVisible ? 'Hide BCC' : 'Add BCC'}
              </button>
              <Input
                {...field}
                placeholder='Bcc'
                size='md'
                rightSectionWidth={60}
                readOnly={
                  action === 'reply' || action === 'replyall' ? true : false
                }
                className={`${isBccVisible ? '' : 'hidden'}`} 
                classNames={{
                  placeholder: 'text-8E8E8E text-sm ml-2',
                  rightSection: 'text-primary text-sm mt-4',
                  input:
                    'bg-transparent border-primary text-sm pl-5 mt-4 2xl:text-lg 3xl:text-xl',
                }}
              />
            </div>
          )}
        />
        {errorMessage('bcc')}
      </div>
          {
            // removing subject if mail is retply or reply all

            <Controller
              name="subject"
              control={control}
              /* rules={{ required: 'required' }} */
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Subject"
                  size="md"
                  /*  rightSection='Subject' */
                  rightSectionWidth={60}
                  readOnly={
                    action === "reply" || action === "replyall" ? true : false
                  }
                  classNames={{
                    placeholder: "text-8E8E8E text-sm ml-2",
                    rightSection: "text-primary text-sm mt-4",
                    input:
                      "bg-transparent border-primary text-sm pl-5 mt-4 2xl:text-lg 3xl:text-xl",
                  }}
                />
              )}
            />
          }
          {errorMessage("subject")}

          <div className="mt-4">
            <Controller
              control={control}
              name="body"
              rules={{ required: "required" }}
              render={({ field }) => (
                <JoditEditor
                  config={config}
                  {...field}
                  value={field.value}
                  onChange={(e) => {}}
                  onBlur={(e) => field.onChange(e)}
                />
              )}
            />
            {errorMessage("body")}
          </div>
          <Controller
            name="checkbox"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Checkbox
                {...field}
                //checked={checked}
                //onChange={(e) => setChecked(e.currentTarget.checked)}
                //checked={field['value'] ?? false}
                // checked={checked}
                // onChange={(event) => setChecked(event.currentTarget.checked)}
                checked={field["value"] ?? false}
                label="Notify when opened"
                disabled
                size="md"
                className="mt-4"
                classNames={{
                  label: "text-neutralsGrey text-sm",
                }}
              />
            )}
          />
          <div className="flex items-center gap-x-6 justify-center mt-8">
            <button
              className="w-30 2xl:w-32 3xl:w-36"
              type="submit"
              onClick={() => setIsDraft(true)}
            >
              <SecondaryButton isLoading={isDraft && sendMail.isLoading}>
                Save as draft
              </SecondaryButton>
            </button>

            <button className="w-30 2xl:w-32 3xl:w-36 " type="submit ">
              <PrimaryButton isLoading={sendMail.isLoading}>Send</PrimaryButton>
            </button>
          </div>
        </form>
      </Modal>

      {/* <button
        onClick={() => setOpened(true)}
        className='2xl:w-40 2xl:text-lg 3xl:w-44 3xl:text-xl'
      >
        <PrimaryButton>+ Compose mail</PrimaryButton>
      </button> */}
    </>
  );
};

export default Composemail;
